import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Routes } from "../../../infrastructure/routes";
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { SecurityGateway } from 'src/app/application/gateway/SecurityGateway';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { InputNumber } from 'primeng/inputnumber';
import { TranslateService } from '@ngx-translate/core';
import { ErrorMessageUtil } from '../../util/error-message-util';
import { AuthRedirectService } from '../../util/auth-redirect.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css'],
  providers: [DialogService]
})
export class LoginPageComponent implements OnInit {
  visibleDialog: boolean = false
  submit: boolean = false
  loginError: boolean = false
  loading: boolean = false
  showLogin: boolean = true;
  showAuthentication: boolean = false;
  authenticationCode: string | undefined
  emailUser: string = '';
  codeError: boolean = false;

  fromTo: string = '';
  adsCode: string = '';

  formGroup: FormGroup = this._formBuilder.group({
    email: ['', Validators.required],
    password: ['', Validators.required],
    authCode1: [null],
    authCode2: [null],
    authCode3: [null],
    authCode4: [null],
    authCode5: [null],
    authCode6: [null]
  })

  carouselItems: string[] = [
    '../../../../assets/img/login_carousel/Imagen_1.jpg',
    // '../../../../assets/img/login_carousel/Imagen_2.jpg',
    // '../../../../assets/img/login_carousel/Imagen3.jpg',
    // '../../../../assets/img/login_carousel/Imagen4.jpg',
    // '../../../../assets/img/login_carousel/Imagen5.jpg',
  ]

  currentImageIndex = 0;

  private intervalId: any;

  ngOnInit() {
    //  //this.showAuthentication = true;

    this.intervalId = setInterval(() => {
      this.nextImage();
    }, 10000);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  nextImage() {
    this.currentImageIndex = (this.currentImageIndex + 1) % this.carouselItems.length;
  }

  constructor(private _router: Router,
    private _formBuilder: FormBuilder,
    private router: Router,
    private _securityGateway: SecurityGateway,
    private _authService: AuthGateway,
    public dialog: DialogService,
    private _messageService: MessageService,
    private _authRedirectService: AuthRedirectService,
    public translate: TranslateService,
    private _activatedRoute: ActivatedRoute,

  ) {
    this._activatedRoute.queryParams.subscribe(queryParams => {
      this.fromTo = queryParams['fromTo'];
    })
    this._activatedRoute.queryParams.subscribe(queryParams => {
      this.adsCode = queryParams['adsCode']
    })
   }

  handleSubmit() {
    this.submit = true
    this.loginError = false
    this.loading = true
    if (this.showAuthentication) {
      this.verifyTwoFactor();
    }else{
          if (this.formGroup.valid) {

      this._securityGateway.doLogin(
        this.formGroup.controls['email'].value,
        this.formGroup.controls['password'].value,
        this.authenticationCode
      ).subscribe({
        next: this.handleSuccessResponse.bind(this),
        error: this.handleErrorResponse.bind(this)
      })
    }

    }
  }

  verifyTwoFactor() {
    this.handleAuthCode()
    if(!this.authenticationCode || this.authenticationCode.length !== 6) {
      this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('LoginPage.LoginErrorMessage') })
      return
    }
    this._securityGateway.verifyTwoFactor(
      this.authenticationCode!,
      this.emailUser
    ).subscribe({
      next: this.handleSuccessResponse.bind(this),
      error: this.handleErrorResponse.bind(this)
    })
  }

  handleSuccessResponse(data: any) {
    if (data?.data.requiresTwoFactor) {
      this.showLogin = false;
      this.showAuthentication = true;
      this.loading = false;
    }
    else if (data?.requiredValidateToken) {
      this.loading = false;
      this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: data?.msg ?? this.translate.instant('LoginPage.LoginErrorMessage') })
    }
    else {
      this._authService.authenticate(
        data.data.accessToken,
        data.data.refreshToken)
      this._authRedirectService.handlePostLoginRedirect().subscribe({
        next: () => {
          this.loading = false;
        },
        error: (e) => {
          this.loading = false;
          console.log(e)
        }
      })
    }
  }

  handleErrorResponse(error: any) {
    if (this.showAuthentication) {
      this.codeError = true;
      this.loading = false;
    } else {
      this.loginError = true;
      this.loading = false;
    }
  }

  get resetPasswordRoute(): string {
    return '/reset-password-request'
  }

  get signupPageRoute(): string {
    return '/signup'
  }

  goToMarketplace() {
    this._router.navigate([Routes.externalMarketplace])
  }

  goToSignupPage() {
    this._router.navigate([Routes.signup])
  }

  goToHome() {
    this._router.navigate([Routes.homePage])
  }

  getErrorMessage(fieldName: string): string {
    if (this.formGroup.controls[fieldName].hasError('required')) {
      return this.translate.instant('FormErrorMessage.FieldValueRequired')
    }
    if (this.formGroup.controls[fieldName].hasError('email')) {
      return this.translate.instant('FormErrorMessage.EmailFieldEmailFormatError')
    }
    return ''
  }

  handleAuthCode() {
    if (this.showAuthentication) {
      let digit1 = this.formGroup.controls['authCode1'].value;
      let digit2 = this.formGroup.controls['authCode2'].value;
      let digit3 = this.formGroup.controls['authCode3'].value;
      let digit4 = this.formGroup.controls['authCode4'].value;
      let digit5 = this.formGroup.controls['authCode5'].value;
      let digit6 = this.formGroup.controls['authCode6'].value;

      this.authenticationCode = "" + digit1 + digit2 + digit3 + digit4 + digit5 + digit6;
      this.emailUser = this.formGroup.controls['email'].value;
    } else {
      this.authenticationCode = undefined;
    }
  }

  handleFocusNext(inputNumber: InputNumber) {
    inputNumber.input.nativeElement.focus()
  }

  clear(auth: string) {
    this.formGroup.controls[auth].setValue(null);
  }

  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData?.getData('text')
    if(pastedText?.length === 6 && !isNaN(parseInt(pastedText))) {
      const digits = [...pastedText]
      this.formGroup.controls['authCode1'].setValue(digits[0])
      this.formGroup.controls['authCode2'].setValue(digits[1])
      this.formGroup.controls['authCode3'].setValue(digits[2])
      this.formGroup.controls['authCode4'].setValue(digits[3])
      this.formGroup.controls['authCode5'].setValue(digits[4])
      this.formGroup.controls['authCode6'].setValue(digits[5])
    }
  }

  resendCode() {
    this.loading = true;
    this._securityGateway.resendTwoFactor(this.formGroup.controls['email'].value).subscribe({
        next: (v) => {
          this.loading = false;
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('LoginPage.ResendCodeSuccess') })
        },
        error: (e) => {
          this.loading = false;
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: ErrorMessageUtil.msgResponseError(e.error,
              this.translate.instant('LoginPage.ResendCodeError')) })
        }
      })
  }

  backTo() {
    if(this.fromTo){
      if(this.fromTo==="offer-detail" && this.adsCode){
        this._router.navigate(['/'+ Routes.offerDetail,this.adsCode])
      }
      if(this.fromTo==="offers" && !this.adsCode){
        this._router.navigate(['/'+ Routes.externalMarketplace])
      }
    }
    else {
      this._router.navigate(['/'+ Routes.homePage])
    }
  }

}
